import logo from './logo.svg';
import './App.css';
// import Header from './components/header/header'
// import Footer from './components/footer/footer'
// import HomePage from './pages/home/home'
// import Button from 'react-bootstrap/Button';

import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router";
import { Provider } from 'react-redux';
import { store } from './store/store';

import HomePage from "./pages/home/index";
import LoginPage from "./pages/login/login";
import Logout from "./pages/myProfile/logout";
import SignUpPage from "./pages/signup/signup";
import ForgetPassswordPage from './pages/forgetPassword/forgetPassword'
import ResetPassswordPage from './pages/forgetPassword/resetPassword'

import SearchPage from "./pages/search/search";
import RentedProperties from './pages/properties/rentedProperties';
import SalesProperties from './pages/properties/salesProperties'
import PostAd from "./pages/postAd/postAd";
import PostAd2 from "./pages/postAd/postAd2";
import PostSuccess from "./pages/postAd/postSuccess";
import MyProfile from "./pages/myProfile/myProfile";
import NotFound from './pages/404/notFound';
import Properties from './pages/properties/properties';
import UpdateProperty from './pages/properties/updateProperty';
import PropertyDetail from './pages/properties/detail';
import Project from './pages/project/project';
import Agents from './pages/properties/agents';
import FeaturedProperties from './pages/properties/featuredProperties';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import ProjectList from './pages/project/projectList';


function App() {
  
  return (
    
      <Provider store={store}>
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path='*'element={<NotFound/>} />
            <Route path='/login'element={<LoginPage/>} />
            <Route path='/signup'element={<SignUpPage/>} />
            <Route path='/forget-password'element={<ForgetPassswordPage/>} />
            <Route path='/reset-password/:token'element={<ResetPassswordPage/>} />
            
            <Route path='/search'element={<SearchPage/>} />
            <Route path='/:type/properties-for-rent/:propertyType'element={<RentedProperties/>} />
            <Route path='/:type/properties-to-buy/:propertyType'element={<SalesProperties/>} />
            {/* <Route path='/:t/properties-for-rent/:type'element={<RentedProperties/>} /> */}
            {/* <Route path='/residential/properties-to-buy/:type'element={<SalesProperties/>} /> */}
            <Route path='/featured-properties'element={<FeaturedProperties/>} />
            
            <Route path='/post-ad/step1'element={<PostAd/>} />
            <Route path='/post-ad/step2'element={<PostAd2/>} />
            <Route path='/post-ad/success'element={<PostSuccess/>} />
            <Route path='/update-profile'element={<MyProfile/>} />
            <Route path='/properties'element={<Properties/>} />
            <Route path='/property/update/:slug'element={<UpdateProperty />} />
            <Route path='/:slug'element={<PropertyDetail />} />
            <Route path='/project/:slug'element={<Project />} />
            <Route path='/projects'element={<ProjectList />} />
            <Route path='/agents'element={<Agents />} />
            <Route path='/logout'element={<Logout />} />

            {/* <Route path='/propery-for-rent'element={<Properties/>} /> */}
            {/* <Route path='/propery-for-sale'element={<Properties/>} /> */}
          </Routes>
        </Router>
      </Provider>
      
  )
}

export default App;
